import { RecommendationsState } from '../../../models';
import { RECOMMENDATIONS_MUTATIONS_KEYS } from '../recommendations.const';
import { RecommendationsMutation } from '../recommendations.interfaces';

export class SetPageMutation implements RecommendationsMutation {
  mutations = {
    [RECOMMENDATIONS_MUTATIONS_KEYS.setPage]: (localState: RecommendationsState, page: number) => {
      localState.page = page;
    }
  };
}
